// extracted by mini-css-extract-plugin
module.exports = {"header":"jusia-insights_header__h7MR1"};